import ComplaintTriageSearchService from '../services/complaint-triage-search-service';

export const complaintTriageSearch = {
  namespaced: true,
  state: {
    searchResult: null,
    pageNumber: 0,
    lastSearchConfig: null,
    complaintTriageStatusesCount: null,
  },
  actions: {
    search({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'standard';
      commit('setLastSearchConfig', data);
      return ComplaintTriageSearchService.search(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setComplaintTriageSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    searchAdvanced({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'advanced';
      commit('setLastSearchConfig', data);
      return ComplaintTriageSearchService.advancedSearch(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setComplaintTriageSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    getComplaintTriageStatusesCount({ commit }) {
      commit('setIsBusy', true, { root: true });
      return ComplaintTriageSearchService.getComplaintTriageStatusesCount()
        .then((result) => {
          commit('setCount', result);
          return result;
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
  },
  mutations: {
    setComplaintTriageSearchResult(state, searchResult) {
      state.searchResult = searchResult;
    },
    setLastSearchConfig(state, searchconfig) {
      state.lastSearchConfig = searchconfig;
    },
    setSearchPageNumber(state, newPageNumber) {
      state.pageNumber = newPageNumber;
    },
    setCount(state, newCount) {
      state.complaintTriageStatusesCount = newCount;
    },
  },
};
